"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ViewedAdContext = exports.ViewSessionContext = exports.AdRankingContext = void 0;
const long_1 = __importDefault(require("long"));
const minimal_1 = __importDefault(require("protobufjs/minimal"));
const wrappers_1 = require("../../google/protobuf/wrappers");
function createBaseAdRankingContext() {
    return {
        viewSession: [],
        operaType: 0,
        timeSinceForegroundMillis: undefined,
        adOrganicSignals: [],
        fourthTabTotalTimeSpentMillis: undefined,
        fourthTabSessionTimeSpentMillis: undefined,
        fourthTabFriendStoriesTotalViewTimeMillis: undefined,
        fourthTabNonFriendStoriesTotalViewTimeMillis: undefined,
        fourthTabFriendStoriesSessionViewTimeMillis: undefined,
        fourthTabNonFriendStoriesSessionViewTimeMillis: undefined,
        snapIds: [],
    };
}
exports.AdRankingContext = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.viewSession) {
            exports.ViewSessionContext.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.operaType !== 0) {
            writer.uint32(16).int32(message.operaType);
        }
        if (message.timeSinceForegroundMillis !== undefined) {
            wrappers_1.Int64Value.encode({ value: message.timeSinceForegroundMillis }, writer.uint32(26).fork()).ldelim();
        }
        for (const v of message.adOrganicSignals) {
            writer.uint32(34).bytes(v);
        }
        if (message.fourthTabTotalTimeSpentMillis !== undefined) {
            wrappers_1.Int64Value.encode({ value: message.fourthTabTotalTimeSpentMillis }, writer.uint32(42).fork()).ldelim();
        }
        if (message.fourthTabSessionTimeSpentMillis !== undefined) {
            wrappers_1.Int64Value.encode({ value: message.fourthTabSessionTimeSpentMillis }, writer.uint32(50).fork()).ldelim();
        }
        if (message.fourthTabFriendStoriesTotalViewTimeMillis !== undefined) {
            wrappers_1.Int64Value.encode({ value: message.fourthTabFriendStoriesTotalViewTimeMillis }, writer.uint32(58).fork()).ldelim();
        }
        if (message.fourthTabNonFriendStoriesTotalViewTimeMillis !== undefined) {
            wrappers_1.Int64Value.encode({ value: message.fourthTabNonFriendStoriesTotalViewTimeMillis }, writer.uint32(66).fork()).ldelim();
        }
        if (message.fourthTabFriendStoriesSessionViewTimeMillis !== undefined) {
            wrappers_1.Int64Value.encode({ value: message.fourthTabFriendStoriesSessionViewTimeMillis }, writer.uint32(74).fork()).ldelim();
        }
        if (message.fourthTabNonFriendStoriesSessionViewTimeMillis !== undefined) {
            wrappers_1.Int64Value.encode({ value: message.fourthTabNonFriendStoriesSessionViewTimeMillis }, writer.uint32(82).fork()).ldelim();
        }
        for (const v of message.snapIds) {
            writer.uint32(90).string(v);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseAdRankingContext();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.viewSession.push(exports.ViewSessionContext.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.operaType = reader.int32();
                    break;
                case 3:
                    message.timeSinceForegroundMillis = wrappers_1.Int64Value.decode(reader, reader.uint32()).value;
                    break;
                case 4:
                    message.adOrganicSignals.push(reader.bytes());
                    break;
                case 5:
                    message.fourthTabTotalTimeSpentMillis = wrappers_1.Int64Value.decode(reader, reader.uint32()).value;
                    break;
                case 6:
                    message.fourthTabSessionTimeSpentMillis = wrappers_1.Int64Value.decode(reader, reader.uint32()).value;
                    break;
                case 7:
                    message.fourthTabFriendStoriesTotalViewTimeMillis = wrappers_1.Int64Value.decode(reader, reader.uint32()).value;
                    break;
                case 8:
                    message.fourthTabNonFriendStoriesTotalViewTimeMillis =
                        wrappers_1.Int64Value.decode(reader, reader.uint32()).value;
                    break;
                case 9:
                    message.fourthTabFriendStoriesSessionViewTimeMillis =
                        wrappers_1.Int64Value.decode(reader, reader.uint32()).value;
                    break;
                case 10:
                    message.fourthTabNonFriendStoriesSessionViewTimeMillis =
                        wrappers_1.Int64Value.decode(reader, reader.uint32()).value;
                    break;
                case 11:
                    message.snapIds.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseAdRankingContext();
        message.viewSession =
            object.viewSession?.map((e) => exports.ViewSessionContext.fromPartial(e)) || [];
        message.operaType = object.operaType ?? 0;
        message.timeSinceForegroundMillis =
            object.timeSinceForegroundMillis ?? undefined;
        message.adOrganicSignals = object.adOrganicSignals?.map((e) => e) || [];
        message.fourthTabTotalTimeSpentMillis =
            object.fourthTabTotalTimeSpentMillis ?? undefined;
        message.fourthTabSessionTimeSpentMillis =
            object.fourthTabSessionTimeSpentMillis ?? undefined;
        message.fourthTabFriendStoriesTotalViewTimeMillis =
            object.fourthTabFriendStoriesTotalViewTimeMillis ?? undefined;
        message.fourthTabNonFriendStoriesTotalViewTimeMillis =
            object.fourthTabNonFriendStoriesTotalViewTimeMillis ?? undefined;
        message.fourthTabFriendStoriesSessionViewTimeMillis =
            object.fourthTabFriendStoriesSessionViewTimeMillis ?? undefined;
        message.fourthTabNonFriendStoriesSessionViewTimeMillis =
            object.fourthTabNonFriendStoriesSessionViewTimeMillis ?? undefined;
        message.snapIds = object.snapIds?.map((e) => e) || [];
        return message;
    },
};
function createBaseViewSessionContext() {
    return {
        startTimestampMillis: "0",
        viewSource: 0,
        timeSinceSessionStartMillis: undefined,
        totalAdSnapViewTimeMillis: undefined,
        totalSnapViewCount: undefined,
        totalAdSnapViewCount: undefined,
        totalAdSwipeUpCount: undefined,
        totalSwipeUpCount: undefined,
        totalAdLongformViewTimeMillis: undefined,
        totalLongformViewTimeMillis: undefined,
        totalStoriesViewCount: undefined,
        availableStoriesCount: undefined,
        exitEvent: 0,
        isLastSnapAd: undefined,
        viewedAd: [],
    };
}
exports.ViewSessionContext = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.startTimestampMillis !== "0") {
            writer.uint32(8).int64(message.startTimestampMillis);
        }
        if (message.viewSource !== 0) {
            writer.uint32(16).int32(message.viewSource);
        }
        if (message.timeSinceSessionStartMillis !== undefined) {
            wrappers_1.Int64Value.encode({ value: message.timeSinceSessionStartMillis }, writer.uint32(26).fork()).ldelim();
        }
        if (message.totalAdSnapViewTimeMillis !== undefined) {
            wrappers_1.Int64Value.encode({ value: message.totalAdSnapViewTimeMillis }, writer.uint32(34).fork()).ldelim();
        }
        if (message.totalSnapViewCount !== undefined) {
            wrappers_1.Int32Value.encode({ value: message.totalSnapViewCount }, writer.uint32(42).fork()).ldelim();
        }
        if (message.totalAdSnapViewCount !== undefined) {
            wrappers_1.Int32Value.encode({ value: message.totalAdSnapViewCount }, writer.uint32(50).fork()).ldelim();
        }
        if (message.totalAdSwipeUpCount !== undefined) {
            wrappers_1.Int32Value.encode({ value: message.totalAdSwipeUpCount }, writer.uint32(58).fork()).ldelim();
        }
        if (message.totalSwipeUpCount !== undefined) {
            wrappers_1.Int32Value.encode({ value: message.totalSwipeUpCount }, writer.uint32(66).fork()).ldelim();
        }
        if (message.totalAdLongformViewTimeMillis !== undefined) {
            wrappers_1.Int64Value.encode({ value: message.totalAdLongformViewTimeMillis }, writer.uint32(74).fork()).ldelim();
        }
        if (message.totalLongformViewTimeMillis !== undefined) {
            wrappers_1.Int64Value.encode({ value: message.totalLongformViewTimeMillis }, writer.uint32(82).fork()).ldelim();
        }
        if (message.totalStoriesViewCount !== undefined) {
            wrappers_1.Int32Value.encode({ value: message.totalStoriesViewCount }, writer.uint32(90).fork()).ldelim();
        }
        if (message.availableStoriesCount !== undefined) {
            wrappers_1.Int32Value.encode({ value: message.availableStoriesCount }, writer.uint32(98).fork()).ldelim();
        }
        if (message.exitEvent !== 0) {
            writer.uint32(104).int32(message.exitEvent);
        }
        if (message.isLastSnapAd !== undefined) {
            wrappers_1.BoolValue.encode({ value: message.isLastSnapAd }, writer.uint32(114).fork()).ldelim();
        }
        for (const v of message.viewedAd) {
            exports.ViewedAdContext.encode(v, writer.uint32(122).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseViewSessionContext();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.startTimestampMillis = longToString(reader.int64());
                    break;
                case 2:
                    message.viewSource = reader.int32();
                    break;
                case 3:
                    message.timeSinceSessionStartMillis = wrappers_1.Int64Value.decode(reader, reader.uint32()).value;
                    break;
                case 4:
                    message.totalAdSnapViewTimeMillis = wrappers_1.Int64Value.decode(reader, reader.uint32()).value;
                    break;
                case 5:
                    message.totalSnapViewCount = wrappers_1.Int32Value.decode(reader, reader.uint32()).value;
                    break;
                case 6:
                    message.totalAdSnapViewCount = wrappers_1.Int32Value.decode(reader, reader.uint32()).value;
                    break;
                case 7:
                    message.totalAdSwipeUpCount = wrappers_1.Int32Value.decode(reader, reader.uint32()).value;
                    break;
                case 8:
                    message.totalSwipeUpCount = wrappers_1.Int32Value.decode(reader, reader.uint32()).value;
                    break;
                case 9:
                    message.totalAdLongformViewTimeMillis = wrappers_1.Int64Value.decode(reader, reader.uint32()).value;
                    break;
                case 10:
                    message.totalLongformViewTimeMillis = wrappers_1.Int64Value.decode(reader, reader.uint32()).value;
                    break;
                case 11:
                    message.totalStoriesViewCount = wrappers_1.Int32Value.decode(reader, reader.uint32()).value;
                    break;
                case 12:
                    message.availableStoriesCount = wrappers_1.Int32Value.decode(reader, reader.uint32()).value;
                    break;
                case 13:
                    message.exitEvent = reader.int32();
                    break;
                case 14:
                    message.isLastSnapAd = wrappers_1.BoolValue.decode(reader, reader.uint32()).value;
                    break;
                case 15:
                    message.viewedAd.push(exports.ViewedAdContext.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseViewSessionContext();
        message.startTimestampMillis = object.startTimestampMillis ?? "0";
        message.viewSource = object.viewSource ?? 0;
        message.timeSinceSessionStartMillis =
            object.timeSinceSessionStartMillis ?? undefined;
        message.totalAdSnapViewTimeMillis =
            object.totalAdSnapViewTimeMillis ?? undefined;
        message.totalSnapViewCount = object.totalSnapViewCount ?? undefined;
        message.totalAdSnapViewCount = object.totalAdSnapViewCount ?? undefined;
        message.totalAdSwipeUpCount = object.totalAdSwipeUpCount ?? undefined;
        message.totalSwipeUpCount = object.totalSwipeUpCount ?? undefined;
        message.totalAdLongformViewTimeMillis =
            object.totalAdLongformViewTimeMillis ?? undefined;
        message.totalLongformViewTimeMillis =
            object.totalLongformViewTimeMillis ?? undefined;
        message.totalStoriesViewCount = object.totalStoriesViewCount ?? undefined;
        message.availableStoriesCount = object.availableStoriesCount ?? undefined;
        message.exitEvent = object.exitEvent ?? 0;
        message.isLastSnapAd = object.isLastSnapAd ?? undefined;
        message.viewedAd =
            object.viewedAd?.map((e) => exports.ViewedAdContext.fromPartial(e)) || [];
        return message;
    },
};
function createBaseViewedAdContext() {
    return {
        adExitEvent: 0,
        adLoadingSpinnerTimeMillis: undefined,
        adViewTimeMillis: undefined,
        adSwipeUp: undefined,
    };
}
exports.ViewedAdContext = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.adExitEvent !== 0) {
            writer.uint32(8).int32(message.adExitEvent);
        }
        if (message.adLoadingSpinnerTimeMillis !== undefined) {
            wrappers_1.Int32Value.encode({ value: message.adLoadingSpinnerTimeMillis }, writer.uint32(18).fork()).ldelim();
        }
        if (message.adViewTimeMillis !== undefined) {
            wrappers_1.Int32Value.encode({ value: message.adViewTimeMillis }, writer.uint32(26).fork()).ldelim();
        }
        if (message.adSwipeUp !== undefined) {
            wrappers_1.BoolValue.encode({ value: message.adSwipeUp }, writer.uint32(34).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseViewedAdContext();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.adExitEvent = reader.int32();
                    break;
                case 2:
                    message.adLoadingSpinnerTimeMillis = wrappers_1.Int32Value.decode(reader, reader.uint32()).value;
                    break;
                case 3:
                    message.adViewTimeMillis = wrappers_1.Int32Value.decode(reader, reader.uint32()).value;
                    break;
                case 4:
                    message.adSwipeUp = wrappers_1.BoolValue.decode(reader, reader.uint32()).value;
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseViewedAdContext();
        message.adExitEvent = object.adExitEvent ?? 0;
        message.adLoadingSpinnerTimeMillis =
            object.adLoadingSpinnerTimeMillis ?? undefined;
        message.adViewTimeMillis = object.adViewTimeMillis ?? undefined;
        message.adSwipeUp = object.adSwipeUp ?? undefined;
        return message;
    },
};
function longToString(long) {
    return long.toString();
}
if (minimal_1.default.util.Long !== long_1.default) {
    minimal_1.default.util.Long = long_1.default;
    minimal_1.default.configure();
}
//# sourceMappingURL=ad_ranking_context.js.map